import "../../assets/css/OrderList.css";
import MangeModal from "../../components/Dashboard/Home/MangeModal/manage";
import SubHeader from "../../components/Dashboard/OrderListComponents/SubHeader";
import OrderContainer from "../../components/Dashboard/OrderListComponents/OrderContainer";
import ChangeStationModal from "../../components/Dashboard/Home/ChangeStationModal/changeStation";

import { Spinner } from "reactstrap";
import { useSelector } from "react-redux";

const OrderList = () => {
  const loading = useSelector((state) => state?.orders.loading);
  const data = useSelector((state) => state.orders.orders);

  // Loading Div
  if (loading) {
    return (
      <>
        <div className="d-flex position-absolute top-50 start-50">
          <Spinner />
        </div>
      </>
    );
  }

  return (
    <>
      <SubHeader />
      <OrderContainer data={data} />
      <MangeModal />
      <ChangeStationModal />
    </>
  );
};

export default OrderList;
